import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b4bd3ae8"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Stai aggiungendo una nuova tipologia di strumento", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Nuova tipologia strumentazione", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Aggiungi le seguenti informazioni", -1))
const _hoisted_4 = { class: "title text-input input-content" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "title" }, "Nome", -1))
const _hoisted_6 = {
  key: 0,
  class: "font-light text-red-500"
}
const _hoisted_7 = { class: "title text-input input-content" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "primary-field-name" }, "Nome primo campo", -1))
const _hoisted_9 = {
  key: 0,
  class: "font-light text-red-500"
}
const _hoisted_10 = { class: "title text-input input-content" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "secondary-field-name" }, "Nome primo campo", -1))
const _hoisted_12 = {
  key: 0,
  class: "font-light text-red-500"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PrimaryButton = _resolveComponent("PrimaryButton")!
  const _component_Loader = _resolveComponent("Loader")!
  const _component_ModalDialog = _resolveComponent("ModalDialog")!

  return (_openBlock(), _createBlock(_component_ModalDialog, null, {
    h1: _withCtx(() => [
      _hoisted_1
    ]),
    h3: _withCtx(() => [
      _hoisted_2
    ]),
    h2: _withCtx(() => [
      _hoisted_3
    ]),
    buttons: _withCtx(() => [
      _createVNode(_component_PrimaryButton, {
        class: "button bg-white text-primary-900 undo",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onClose()))
      }, {
        default: _withCtx(() => [
          _createTextVNode("Annulla")
        ]),
        _: 1
      }),
      _createVNode(_component_PrimaryButton, {
        class: "button bg-primary-900 text-white",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onConfirm()))
      }, {
        default: _withCtx(() => [
          _createTextVNode("Crea")
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _withDirectives(_createElementVNode("input", {
          class: _normalizeClass(["bg-primary-50 border-red-400", { border: _ctx.v$.title.$error }]),
          id: "title",
          type: "text",
          placeholder: "Inserisci il nome della tipologia di strumento",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.title) = $event)),
          onBlur: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.v$.title.$touch && _ctx.v$.title.$touch(...args)))
        }, null, 34), [
          [_vModelText, _ctx.title]
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.title.$errors, (error) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "errors",
            key: error.$uid
          }, [
            (error.$validator == 'required')
              ? (_openBlock(), _createElementBlock("label", _hoisted_6, "È necessario inserire il nome della tipologia di strumento"))
              : _createCommentVNode("", true)
          ]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _withDirectives(_createElementVNode("input", {
          class: _normalizeClass(["bg-primary-50 border-red-400", { border: _ctx.v$.primaryFieldName.$error }]),
          id: "primary-field-name",
          type: "text",
          placeholder: "Inserisci il nome del primo campo",
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.primaryFieldName) = $event)),
          onBlur: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.v$.primaryFieldName.$touch && _ctx.v$.primaryFieldName.$touch(...args)))
        }, null, 34), [
          [_vModelText, _ctx.primaryFieldName]
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.primaryFieldName.$errors, (error) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "errors",
            key: error.$uid
          }, [
            (error.$validator == 'required')
              ? (_openBlock(), _createElementBlock("label", _hoisted_9, "È necessario inserire il nome del primo campo"))
              : _createCommentVNode("", true)
          ]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_10, [
        _hoisted_11,
        _withDirectives(_createElementVNode("input", {
          class: _normalizeClass(["bg-primary-50 border-red-400", { border: _ctx.v$.secondaryFieldName.$error }]),
          id: "secondary-field-name",
          type: "text",
          placeholder: "Inserisci il nome del secondo campo",
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.secondaryFieldName) = $event)),
          onBlur: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.v$.secondaryFieldName.$touch && _ctx.v$.secondaryFieldName.$touch(...args)))
        }, null, 34), [
          [_vModelText, _ctx.secondaryFieldName]
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.secondaryFieldName.$errors, (error) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "errors",
            key: error.$uid
          }, [
            (error.$validator == 'required')
              ? (_openBlock(), _createElementBlock("label", _hoisted_12, "È necessario inserire il nome del primo campo"))
              : _createCommentVNode("", true)
          ]))
        }), 128))
      ]),
      (_ctx.loading)
        ? (_openBlock(), _createBlock(_component_Loader, {
            key: 0,
            message: "Salvataggio..."
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}